<template>
    <div class="">
        <div class="parallax-5 behind-text"></div>
         <div class="wrapper top-nav">

            <div class="branding on-the-top">
                <a href="/" rel="home"><img width="155" class="logo" src="/images/logo.png"></a>
            </div>

            <nav class="navigation column">
                <ul class="menu">
                    

                    <li class="menu-item  on-the-top">
                        <a style="color:#727272" href="/">Home</a>
                    </li>

                    <!-- <li style="margin-left: 30px;width: 120px;" v-if="!user & !isOwner" class="menu-item">
                        <a style="width:100%" class="btn btn-cancel" href="/registerbuilding">Get Started</a>
                    </li> -->

                    <!-- <li>
                        <v-row align="center">
                            <v-menu
                                v-model="value"
                                :disabled="disabled"
                                :absolute="absolute"
                                :open-on-hover="openOnHover"
                                :close-on-click="closeOnClick"
                                :close-on-content-click="closeOnContentClick"
                                :offset-x="offsetX"
                                :offset-y="offsetY"
                                >
                                <template v-slot:activator="{ props }">
                                    <v-btn
                                        class="text-capitalize font-weight-bold"
                                        v-ripple="{ class: 'transparent--text' }" variant="text"
                                        dark
                                        v-bind="props">
                                        Careers
                                    </v-btn>
                                </template>
                                <v-list>
                                    <v-list-item
                                        v-for="(item, index) in items"
                                        :key="index"
                                        :to="item.link"
                                        >
                                        <v-list-item-title>{{ item.title }}</v-list-item-title>
                                    </v-list-item>
                                </v-list>
                            </v-menu>
                        </v-row>
                    </li> -->

                    <li class="menu-item last  on-the-top">
                        <router-link style="color:#727272" v-if="!user" :to="{ name: 'login'}">Platform</router-link>
                        <router-link style="color:#727272" v-else-if="isOwner" :to="{ name: 'propertiesowner'}">Platform</router-link>
                        <router-link style="color:#727272" v-else  :to="{ name: 'buildings'}">Platform</router-link>
                    </li>

                </ul>
            </nav>
        </div>
        <div class="row">
            <div class='col-12 col-md-11 col-lg-8 col-md-offset-2' id='loginDiv' style="padding:50px; margin-top:35px; margin-bottom:35px">
                <div class="row">
                    <div class="col-12">
                        <div style='padding:40px' class='col-12'>
                            <h1 style='font-weight:bold; font-size:25px; text-align:center; margin-top:-45px; padding-top:30px'>Request Form</h1>
                        </div>
                    </div>
                </div>
                <div class="form-group"
                     style="padding-left: 15px; padding-right: 15px;">
                    <label>Name: *</label>
                    <input type="text"
                           v-model="name"
                           placeholder='Name'
                           class="form-control" />
                    <div v-if="!name && submitted" class="invalid">Please provide a name.</div>
                </div>

                <div class="form-group"
                     style="padding-left: 15px; padding-right: 15px;">
                    <label>Surname: *</label>
                    <input type="text"
                           v-model="surname"
                           placeholder='Surname'
                           class="form-control" />
                    <div v-if="!surname && submitted" class="invalid">Please provide a surname.</div>
                </div>

                <div class="form-group"
                     style="padding-left: 15px; padding-right: 15px;">
                    <label>Company Name:</label>
                    <input type="text"
                           v-model="companyName" placeholder='Company Name'
                           class="form-control" />
                </div>

                <div class="form-group"
                     style="padding-left: 15px; padding-right: 15px;">
                    <label>Number of Buildings:</label>
                    <input type="number" style="width:100%"
                           v-model="numberOfBuildings" placeholder='Number of Buildings'
                           class="form-control" />
                </div>

                <div class="form-group"
                     style="padding-left: 15px; padding-right: 15px;">
                    <label>Country: *</label>
                    <input type="text"
                           v-model="country" placeholder='Country'
                           class="form-control" />
                    <div v-if="!country && submitted" class="invalid">Please provide a country.</div>
                </div>

                <div class="form-group"
                     style="padding-left: 15px; padding-right: 15px;">
                    <label>City: *</label>
                    <input type="text"
                           v-model="city" placeholder='City'
                           class="form-control" />
                    <div v-if="!city && submitted" class="invalid">Please provide city.</div>
                </div>

                <div class="form-group"
                     style="padding-left: 15px; padding-right: 15px;">
                    <label>Address: *</label>
                    <input type="text"
                           v-model="address" placeholder='Address'
                           class="form-control" />
                    <div v-if="!address && submitted" class="invalid">Please provide address.</div>
                </div>

                <div class="form-group"
                     style="padding-left: 15px; padding-right: 15px;">
                    <label>Postal Code: *</label>
                    <input type="text"
                           v-model="postalCode" placeholder='Postal Code'
                           class="form-control" />
                    <div v-if="!postalCode && submitted" class="invalid">Please provide postal code.</div>
                </div>

                <div class="form-group"
                     style="padding-left: 15px; padding-right: 15px;">
                    <label>Email: *</label>
                    <input type="email"
                           v-model="email" placeholder='Email'
                           class="form-control" />
                    <div v-if="submitted && !email || submitted && !emailIsValid" class="invalid">Please provide a valid email.</div>
                </div>
                <div class="form-group"
                     style="padding-left: 15px; padding-right: 15px;">
                    <label>Phone Number:</label>
                    <input type="number" style="width:100%"
                           v-model="phone" placeholder='Phone Number'
                           class="form-control" />
                </div>

                <div class="form-group"
                     style="padding-left: 15px; padding-right: 15px;">
                    <label>Comments:</label>
                    <input textarea type="text" rows="2"
                           v-model="comments" placeholder='Comments'
                           class="form-control" />
                </div>

                <div class="form-check" style="margin-left:15px">
                    <input type="checkbox" class="form-check-input" v-model="agreement" />
                    <label style="margin-top:10px; margin-left:10px; color:#2C2C2C"
                           class="form-check-label"
                           for="agreement">
                        I agree with <a href="javascript:void(0);" @click="showModalTerms()">Terms and Conditions</a>

                        <modal :scrollable="true"
                               name="terms-and-conditions"
                               @before-open="beforeOpen"
                               height="auto"
                               :minHeight="800"
                               width="80%">
                            <div class="" id="termsModal" role="dialog">
                                <div class="">
                                    <!-- Modal content-->
                                    <terms-and-conditions />
                                </div>
                            </div>
                        </modal>
                    </label>
                    <div v-if="agreement==false && submitted"
                         class="invalid">Agree on Terms and Conditions to proceed.</div>
                </div>
                <div class="text-right">
                    <button type="submit" @click="submitForm()" class="btn btn-submit" style="margin: 15px;">
                        Submit
                    </button>
                    <button @click="$router.go(-1)" class="btn btn-cancel">Cancel</button>
                </div>

                <!-- MODAL IS HERE -->
                <modal :scrollable="true"
                       name="submissionFailure"
                       @before-open="beforeOpen"
                       height="auto"
                       :minHeight="150"
                       width="400">
                    <div class role="document" :message="message">
                        <div class>
                            <!-- Modal content-->
                            <submissionFailure />
                        </div>
                    </div>
                </modal>

                <!-- MODAL FOR SUCCESS IS HERE -->
                <modal :scrollable="true"
                       name="emptyModal"
                       @before-open="beforeOpen"
                       height="auto"
                       :minHeight="150"
                       width="400">
                    <div class role="document">
                        <div class>
                            <!-- Modal content-->
                            <emptyModal :message="message"
                                        :functionForModal="functionForModal"
                                        :buttonSign="buttonSign" />
                        </div>
                    </div>
                </modal>
            </div>
        </div>
    </div>
</template>

<style scoped>
.on-the-top{
    z-index:1;
    margin-top:-10px
}
.behind-text{
    z-index: 0!important;
    margin-left:-12px;
    margin-top:-12px;

}
.v-btn::before {
    background-color: transparent;
    text-decoration: underline
}

.v-btn:hover {
    text-decoration: underline
}

.v-btn{
    margin-top:-16px;
    font-size: 17px!important;
    letter-spacing: .01em;
    width:80px
}
.invalid {
  color: #c7254e !important;
  font-size: 13px !important;
  text-align: left !important;
}
ul.a {
  list-style-type: circle!important
}
h5{
    font-weight: bold;
}
h4{
    font-weight: bold;
}
#loginDiv{
    margin: auto;
    padding: 20px;
    border-radius: 6px;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
    background-color: white;
    line-height: 2
}
#logoLoginPage{
    margin-top: -20px;
    display: block;
    margin-left: auto;
    margin-right: auto;    
}

h2{
    margin-top:-25px; 
    text-align:center; 
    font-size: 20px; 
    color: black; 
    font-style: bolder;
    
}
#footerLoginDiv{
    border-top: 1px solid rgb(182, 179, 179);
    height: 30px;
}
</style>

<script>
export default {
    data() {
        return {
          items: [
                { title: 'Web developer', link:'/careers/webdeveloper' },
                { title: 'Customer service & support officer', link:'/careers/customerservice'},
            ],
            disabled: false,
            absolute: false,
            openOnHover: false,
            value: false,
            closeOnClick: true,
            closeOnContentClick: true,
            offsetX: false,
            offsetY: true,
            name:'',
            surname:'',
            companyName:'',
            numberOfBuildings:1,
            country:'',
            city:'',
            address:'',
            email:'',
            phone: '',
            postalCode:'',
            comments:'',
            agreement: false,
            submitted:false,
            message:'Form was submitted successfully!',
            buttonSign: 'OK, go to Home Page'
        }
    },
    methods: {
      showModalTerms: function () {
        this.$modal.show("terms-and-conditions");
      },
      submitForm: function(){            
          this.submitted = true
          if (this.formIsValid){
              this.$http.post('/email/register', {
                  firstName: this.name,
                  lastName: this.surname,
                  companyName: this.companyName,
                  numberOfBuildings: this.numberOfBuildings,
                  country: this.country,
                  city: this.city,
                  address: this.address,
                  postalCode: this.postalCode,
                  email: this.email,
                  phoneNumber: this.phone,
                  comments: this.comments,
                  agreement: this.agreement
              }).then(() => {
                  this.submitted = false;
                  this.submissionSuccess();
                  this.clearForm();          
              }, () => {   
                  this.submissionFailure()
              })
          }
        },
        clearForm: function() {
            this.name='',
            this.surname='',
            this.companyName='',
            this.numberOfBuildings='',
            this.country='',
            this.city='',
                this.address = '',
                this.postalCode = '',
            this.email='',
            this.phone='',
            this.comments='',
            this.agreement= false,
            this.submitted=false
        },
        submissionFailure: function(){
            this.$modal.show('submissionFailure');
        },
        submissionSuccess: function(){
            this.$modal.show('emptyModal');
        },
        functionForModal: function () {
            this.$router.push('homepage')
        }
        
    },
    computed:{
        formIsValid (){
            return this.name && this.surname && this.email && this.country && this.agreement && this.emailIsValid && this.postalCode && this.city && this.address
        },
        emailIsValid: function () {
            if(this.email.includes('@')){
                return true
            }

            return false
        }
    }
}

</script>
